import { getEditedContactData } from '../utils';
import { EDITABLE_KEYS } from './consts';
function getMetadata(currentMetadata, isRevert) {
    return Object.assign(Object.assign({}, currentMetadata), { isEdited: !isRevert && !(currentMetadata === null || currentMetadata === void 0 ? void 0 : currentMetadata.isManuallyAdded) });
}
function setEditedValues({ data, index, metadata, value, isRevert }) {
    data[index] = value;
    metadata[index] = getMetadata(metadata[index], isRevert);
    if (!value && metadata[index].isManuallyAdded) {
        data.splice(index, 1);
        metadata.splice(index, 1);
    }
}
function getEditedData({ contact, contactKey, inputValue, isRevert }) {
    const { emails, emailsMetadata, phones, phonesMetadata } = getEditedContactData(contact);
    const value = isRevert ? null : inputValue;
    let itemType;
    switch (contactKey) {
        case EDITABLE_KEYS.email1:
            setEditedValues({
                data: emails,
                index: 0,
                metadata: emailsMetadata,
                value,
                isRevert,
            });
            itemType = 'contact_email';
            break;
        case EDITABLE_KEYS.email2:
            setEditedValues({
                data: emails,
                index: 1,
                metadata: emailsMetadata,
                value,
                isRevert,
            });
            itemType = 'contact_email';
            break;
        case EDITABLE_KEYS.phone1:
            setEditedValues({
                data: phones,
                index: 0,
                metadata: phonesMetadata,
                value,
                isRevert,
            });
            itemType = 'contact_phone';
            break;
        case EDITABLE_KEYS.phone2:
            setEditedValues({
                data: phones,
                index: 1,
                metadata: phonesMetadata,
                value,
                isRevert,
            });
            itemType = 'contact_phone';
            break;
        case EDITABLE_KEYS.title:
            return {
                jobTitle: {
                    title: value,
                },
                itemType: 'contact_title',
            };
        default:
            return {};
    }
    return {
        phones,
        phonesMetadata,
        emails,
        emailsMetadata,
        itemType,
    };
}
export { getEditedData };
